import { logEvent } from './logEvent';
import { type TDict } from './types';

export function logEventString(name: string, value: string, additional: TDict = {}) {
    return logEvent('string', name, value, additional);
}
